import { SVGProps } from "react";

export default function EmailNotificationIcon(props: SVGProps<SVGSVGElement>) {
  const {
    height = 24,
    width = 24,
    stroke = "#FFBA9D",
    fill = "#FF6929",
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M19.5 3.5C20.6046 3.5 21.5 4.39543 21.5 5.5C21.5 6.60457 20.6046 7.5 19.5 7.5C18.3954 7.5 17.5 6.60457 17.5 5.5C17.5 4.39543 18.3954 3.5 19.5 3.5Z"
        stroke={stroke}
      />
      <path
        d="M19.5 3.5C20.6046 3.5 21.5 4.39543 21.5 5.5C21.5 6.60457 20.6046 7.5 19.5 7.5C18.3954 7.5 17.5 6.60457 17.5 5.5C17.5 4.39543 18.3954 3.5 19.5 3.5Z"
        stroke={stroke}
      />
      <path
        d="M20.72 9.31C20.02 9.53 19.25 9.57 18.45 9.37C17.11 9.02 16.02 7.95 15.65 6.61C15.47 5.96 15.46 5.32 15.57 4.74C15.7 4.1 15.25 3.5 14.61 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V10.26C22 9.6 21.36 9.1 20.72 9.31ZM15.52 11.15L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L14.58 9.97C14.9 9.71 15.38 9.76 15.63 10.09C15.89 10.41 15.84 10.89 15.52 11.15Z"
        fill={fill}
      />
    </svg>
  );
}
